<template>
  <div class="buttons">
    <ButtonComponent
      v-for="(button, index) in buttons"
      :key="button.label"
      @buttonClicked="buttonClicked(button, index)"
      :button="button"
      :theme="selectButtonTheme(button.action)"
      :disabled="isDisabled"
      :isLoading="isDisabled && clickedIndex === index"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ButtonComponent from "./Button.vue";
import { button, theme } from "@entersekt/types/build/3-5-0/endpoint";

export default defineComponent({
  name: "ButtonsComponent",
  components: { ButtonComponent },

  data() {
    return {
      // Position of the last clicked button, so only that button shows the
      // spinner once the parent disables the buttons
      clickedIndex: -1,
    };
  },

  setup() {
    const defaultColor = "#000000";
    return { defaultColor };
  },
  props: {
    buttons: {
      required: true,
      type: Array as PropType<button[]>,
    },
    theme: {
      type: Object as PropType<theme>,
    },
    // Locks the buttons after a click until the next page loads, so nobody can
    // click twice. Not set if Continue fails validation, so the user can fix it
    isDisabled: {
      type: Boolean,
    },
  },

  methods: {
    buttonClicked(clickedButton: button, index: number) {
      this.clickedIndex = index;
      this.$emit(
        "buttonClicked",
        clickedButton.action,
        clickedButton.actionNext,
      );
    },

    selectButtonTheme(action: button.action | undefined): string {
      if (!this.theme) {
        return this.defaultColor;
      }
      switch (action) {
        case button.action.CONTINUE: {
          if (this.theme.buttonPrimaryBackgroundColor) {
            return this.theme.buttonPrimaryBackgroundColor;
          }
          break;
        }
        case button.action.CANCEL: {
          if (this.theme.buttonSecondaryBackgroundColor) {
            return this.theme.buttonSecondaryBackgroundColor;
          }
          break;
        }
        case button.action.CANCEL_AND: {
          if (this.theme.buttonTertiaryBackgroundColor) {
            return this.theme.buttonTertiaryBackgroundColor;
          }
          break;
        }
        default: {
          return this.defaultColor;
        }
      }
      return this.defaultColor;
    },
  },

  emits: ["buttonClicked"],
});
</script>

<style scoped>
.buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  column-gap: 20px;
}
</style>
